import type { MouseEventHandler } from 'react';
import { useEffect } from 'react';

import { Analytics } from '@trello/atlassian-analytics';

import { noop } from 'app/src/noop';
import {
  DeprecatedEditCardButton,
  useDeprecatedEditCardButton,
} from './DeprecatedEditCardButton';

import styles from './SeparatorCard.less';

interface SeparatorCardPropTypes {
  deprecated_openEditor?: MouseEventHandler<HTMLButtonElement>;
  deprecated_isEditable?: boolean;
  analyticsContainers: Parameters<
    typeof Analytics.sendViewedComponentEvent
  >[0]['containers'];
}

export const SeparatorCard = ({
  deprecated_openEditor = noop,
  deprecated_isEditable = false,
  analyticsContainers,
}: SeparatorCardPropTypes) => {
  const { showEditCardButton, hideEditCardButton, shouldShowEditCardButton } =
    useDeprecatedEditCardButton();

  useEffect(() => {
    Analytics.sendViewedComponentEvent({
      componentType: 'card',
      componentName: 'separatorCard',
      source: 'cardView',
      containers: analyticsContainers,
    });
  }, [analyticsContainers]);

  return (
    <div
      onFocus={showEditCardButton}
      onBlur={hideEditCardButton}
      onMouseOver={showEditCardButton}
      onMouseOut={hideEditCardButton}
    >
      <span
        className={styles.separatorCardFront}
        role="separator"
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
      />
      <DeprecatedEditCardButton
        onClick={deprecated_openEditor}
        shouldShow={deprecated_isEditable && shouldShowEditCardButton}
      />
    </div>
  );
};
